<template>
  <div>
    <div class="service-list" v-for="(item,index) in serviceList" :key="index">
      <a v-if="item.url" :href="item.url" target="_blank">
        <img :src="concatImageUrl(item.image)" />
      </a>
      <img v-else :src="concatImageUrl(item.image)" />
    </div>
    <friend-link v-show="siteConfig.agencyId!=0"></friend-link>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { home } from "../../request";
import FriendLink from "./FriendLink";
export default {
  mixins: [siteMixin],
  data() {
    return {
      serviceList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.siteConfig.agencyId == 0) return;
      home.getThemeData(this.siteConfig.agencyId).then((result) => {
        if (result.status === 1) {
          if (result.data.service) {
            this.serviceList = result.data.service.pageSetList;
          }
        }
      });
    },
  },
  components: {
    FriendLink,
  },
};
</script>

<style lang="less" scoped>
.service-list {
  width: 100%;
  text-align: center;
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}
.service-container {
  width: 100%;
}
</style>